module.exports = __webpack_public_path__ + "static/student_videos-9e41fe265c418318694f50a989a865e3.jpg";